var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "empty-calendar-screen" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "empty-calendar-screen__message" }, [
      _c("h2", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.$t("calendar", "Public calendar does not exist")) +
            "\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(
              _vm.$t("calendar", "Maybe the share was deleted or has expired?")
            ) +
            "\n\t\t"
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-calendar-screen__icon" }, [
      _c("div", { staticClass: "icon icon-calendar-dark" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }